export enum UserType {
  Unknown = 0,
  Ofqual = 1,
  CCEA = 2,
  AO = 3,
  Magic = 4,
}

export type UserState = {
  upn: string;
  displayName: string;
  token: string;
  roles: number[];
  userType: UserType;
  subscribeToEmails: boolean;
  acceptedTerms: boolean;
  org: {
    id: number;
    name: string;
  };
  experimentalFeatures?: {
    moduleName: string;
    featureName: string;
    toggleType: number;
  }[];
};

export type AuthState = {
  user: UserState | null;
  loginStatus: "LOGGING_IN" | "LOGGED_IN" | "NOT_LOGGED_IN";
};
